import React from "react";
import "./draw-game.css";

export default function DrawGame({
  background,
  button,
  logo,
}: {
  logo?: string;
  button?: string;
  background?: string;
  isMobile: boolean;
}) {
  // const [isAnimating, setIsAnimating] = useState(false);

  // const handleAnimationEnd = () => {
  //   afterAnimation();
  //   setIsAnimating(false);
  // };

  // const startAnimation = () => {
  //   setIsAnimating(true);
  // };

  const afterAnimation = () => {
    const url = [
      'https://truemateau.org/RFGOLD6GROUP' ,
      // 'https://skyrooaus.org/RFGOLD5GROUP',
      'https://pg9aus.org/RFGOLD1GROUP',
      'https://h4winaus.org/RFGOLD2GROUP',
      'https://rr4winau.org/RFGOLD3GROUP',
      // 'https://rr4winau.org/RFGOLD3GROUP',
      'https://boomerangaus.org/RFGOLD4GROUP',
      'https://truemateau.org/RFGOLD6GROUP'

      // 'https://boomerangaus.org/RFGOLD4GROUP',
      // 'https://pg9aus.org/RFGOLD1GROUP',
    ];
    const randomItem = url[Math.floor(Math.random() * url.length)];
    const newWindow = window.open(randomItem, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.focus();
  };

  return (
    <button
      style={{
        padding: "0px",
        margin: "0px",
        backgroundColor: "transparent",
        border: "none",
      }}
      onClick={afterAnimation}
    >
      <div
        className={`draw-item`}
        style={{
          display: "flex",
          alignItems: "flex-end",
          height: "98.5%",
          marginBottom: "3px",
        }}
      >
        <img
          // onAnimationEnd={handleAnimationEnd}
          // className={`${isAnimating ? "spin-3x" : ""}`}
          src={logo}
          width={"62%"}
          alt="Draw now"
          style={{
            objectFit: "contain",
            position: "absolute",
            top: 0,
            left: "19%",
            right: "19%",
            zIndex: 999,
          }}
        />
        <img
          className="draw-item-bg"
          src={background}
          width={"100%"}
          alt="Draw now"
          style={{ objectFit: "contain" }}
        />
        <div
          style={{
            bottom: 0,
            left: 0,
            right: 0,
            padding: "20px",
            position: "absolute",
            display: "flex",
            justifyContent: "space-around",
            flexDirection: "column",
          }}
        >
          <img src={button} alt="ButtonBg" className={`draw-animation`} />
        </div>
      </div>
    </button>
  );
}
